import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=f78677d4&scoped=true"
import script from "./Tag.vue?vue&type=script&lang=js"
export * from "./Tag.vue?vue&type=script&lang=js"
import style0 from "./Tag.vue?vue&type=style&index=0&id=f78677d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78677d4",
  null
  
)

export default component.exports